import { gridOptions } from "../../utils/globalOptions";

const stateConfig = (labels, dataArray) => {
  const sharedOptions = {
    maintainAspectRatio: false,
    responsive: true,
    legend: {
      display: false,
    },
  };

  const barPercentage = 0.7;

  const colors = [
    {
      backgroundColor: "#97D576",
      borderColor: "#58A82E",
      pointBackgroundColor: "#58A82E",
      pointBorderColor: "#58A82E",
      hoverBackgroundColor: "#2F8401",
    },
  ];

  const datasets = [
    {
      label: "Total de personas evacuadas",
      ...colors[0],
      borderWidth: 1,
      data: dataArray,
      barPercentage,
    },
  ];

  const data = {
    labels,
    datasets,
  };

  return {
    type: "bar",
    title: "Total de personas evacuadas",
    subtitle: "Distribuidas por provincia",
    data,
    options: {
      ...sharedOptions,
      ...gridOptions,
      plugins: {
        // Change options for ALL labels of THIS CHART
        datalabels: {
          display: false,
        },
      },
    },
  };
};

export default stateConfig;
